import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, TextInput, View, ScrollView, Text, StyleSheet, KeyboardAvoidingView, Platform, useWindowDimensions } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { useCssStyle } from "../../customHook/getCssStyle";
import CustomPressable from "../customPressable/customPressable";
import style, { BACKGROUND_COLOR, LIST_SUB_TEXT, MAIN_HEADER_SUB_TITLE, MAIN_HEADER_TITLE, SELECTOR_COL_SECONDARY } from "../../style";
import CustomDropDown from "../customDropdown/customDropdown";
import CustomFlatList from "../customFlatList";
import { CustomTextInput } from "../customTextInput";
import DatePickerModal from "../datePickerModal/datePickerModal";
import moment from "moment";
import { formatDate } from "../../js/formatDate";
import { setRenderFlashMessage } from "../../Redux/Actions/appConfigAction";
import { emailRegex } from "../../utils/validation";
import CustomCheckBoxWithProps from "../checkBox/customCheckBox";
import RenderHTML from "react-native-render-html";

export const DynamicForm = (props) => {
    const { dynamicFormData, dynamicFormDataValue = {}, guestDetails = {}, primaryButtonText, handleGoBack, handleNext, primaryBtnTxt, secondaryBtnTxt } = props;
    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { width } = useWindowDimensions();

    const { mobileCheckInConfigs } = useSelector(state => state.deviceConfigSlice.webAppWidgetsInfo);
    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice)


    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;
    const dateFormat = extraConfigParam?.DATE_FORMAT;

    const { country: countryList } = useSelector(state => state.countryListSlice);
    const [stateList, setStateList] = useState([]);

    const [etaList, setETAList] = useState([]);
    const [openAddress, setOpenAddress] = useState(true);
    const [isAddressMandatory, setIsAddressMandatory] = useState(false);
    const [address, setAddress] = useState({
        addressLine1: "",
        addressLine2: "",
        state: "",
        city: "",
        postalCode: "",
        country: ""
    })

    const [extraData, setExtraData] = useState({});


    const [datePickerConfig, setDatePickerConfig] = useState({
        isVisible: false,
        selectedDate: null,
        fieldKey: null,
        parentObjectFieldKey: null,
    })
    const tweekDatePicker = (isVisible, selectedDate, fieldKey, parentObjectFieldKey) => {
        setDatePickerConfig({
            isVisible: isVisible, 
            selectedDate: isVisible ? selectedDate : null,
            fieldKey: isVisible ? fieldKey: null, 
            parentObjectFieldKey: isVisible ? parentObjectFieldKey : null
        });
    }


    const formatEstimateCheckInTime = (time, timeFormat12hrs) => {

        if (!time) {
            return "";
        }

        const [hours, minutes] = time.split(":");

        if (timeFormat12hrs) {
            let period = "AM";
            let hour = parseInt(hours, 10);

            if (hour >= 12) {
                period = "PM";
                if (hour > 12) {
                    hour -= 12;
                }
            }

            return `${hour}:${minutes} ${period}`;
        } else {
            return `${hours}:${minutes}`;
        }
    }

    const generateETAList = () => {
        const options = [];
        for (let hours = 0; hours < 24; hours++) {
            for (let minutes = 0; minutes < 60; minutes += 30) {
                const hourString = String(hours).padStart(2, '0');
                const minuteString = String(minutes).padStart(2, '0');
                const timeValue = `${hourString}:${minuteString}`;
                const formatedTimeValue = timeValue;
                options.push(formatedTimeValue);
            }
        }

        setETAList(options);
    };


    const handleFormSubmit = () => {
        const proceed = validateMandatoryFields(dynamicFormData, extraData);
    
        if (proceed) {
            console.log({ ...extraData, address });
            handleNext({ ...extraData, address });
        }
    };


    const validateMandatoryFields = (formList, currentData) => {

        for (const field of formList) {
            const { type, fieldKey, fieldName, mandatoryMessage, mandatory, conditionalMandatory, dependency, dependencyData, nestedKeys } = field;
    
            // Handle address (assumed only once, not nested)
            if (type === "address") {
                if (mandatory) {
                    if (!address.country?.trim()) {
                        dispatch(setRenderFlashMessage(true, { type: "danger", message: mandatoryMessage || "Please select your country" }));
                        return false;
                    }
    
                    if (stateList.length > 0 && !address.state?.trim()) {
                        dispatch(setRenderFlashMessage(true, { type: "danger", message: mandatoryMessage || "Please select your state" }));
                        return false;
                    }
    
                    if (!address.addressLine1?.trim()) {
                        dispatch(setRenderFlashMessage(true, { type: "danger", message: mandatoryMessage || "Please enter your address" }));
                        return false;
                    }
    
                    if (!address.city?.trim()) {
                        dispatch(setRenderFlashMessage(true, { type: "danger", message: mandatoryMessage || "Please enter your city" }));
                        return false;
                    }
    
                    if (!address.postalCode?.trim()) {
                        dispatch(setRenderFlashMessage(true, { type: "danger", message: mandatoryMessage || "Please provide your postal code" }));
                        return false;
                    }
                }
                continue;
            }
    
            // Skip non-field types like noticeText
            if (!fieldKey && type !== "nestedObject") continue;
    
            // Check dependency before continuing
            if (dependency) {
                const depValue = getNestedValue(extraData, dependencyData?.dependencyfieldKey);
                if (depValue !== dependencyData?.dependencyValue) continue;
            }
    
            // Handle nested object recursively
            if (type === "nestedObject") {
                const nestedData = currentData?.[fieldKey] || {};
                const isValid = validateMandatoryFields(nestedKeys, nestedData);
                if (!isValid) return false;
                continue;
            }
    
            // Mandatory field check
            if (mandatory) {
                const value = currentData?.[fieldKey];
                if ((typeof value == "boolean" && !value) || (!value?.toString().trim())) {
                    dispatch(setRenderFlashMessage(true, { type: "danger", message: mandatoryMessage ? mandatoryMessage : fieldName ? `Please enter your ${fieldName}` : "Please enter all the required details" }));
                    return false;
                }
            }

            if (conditionalMandatory) {
                const { conditionalDataCondition, conditionDataFieldKey, conditionalDataValue } = field.conditionData
                
                if(!currentData?.[fieldKey]){
                    if(conditionalDataCondition == "nonEmpty"){
                        if(getNestedValue(extraData, conditionDataFieldKey)){
                            dispatch(setRenderFlashMessage(true, { type: "danger", message: mandatoryMessage ? mandatoryMessage : fieldName ? `Please enter your ${fieldName}` : "Please enter all the required details" }));
                            return false
                        }
                    }
    
                    if(conditionalDataCondition == "conditionalDataValue"){
                        if(getNestedValue(extraData, conditionDataFieldKey) == String(conditionalDataValue) ){
                            dispatch(setRenderFlashMessage(true, { type: "danger", message: mandatoryMessage ? mandatoryMessage : fieldName ? `Please enter your ${fieldName}` : "Please enter all the required details" }));
                            return false
                        }
                    }
                }
            }
    
            // Email format validation
            if (type === "email") {
                const email = currentData?.[fieldKey];
                if (email && !emailRegex.test(email)) {
                    dispatch(setRenderFlashMessage(true, { type: "danger", message: mandatoryMessage || `Please enter a valid email` }));
                    return false;
                }
            }
        }
        
        return true;
    };
    


    const addressHandler = (value, property) => {

        let updtAdd;

        if (property) {

            if (value) {
                property == "country" ?
                    updtAdd = { ...address, [property]: value, ["state"]: "" } :
                    updtAdd = { ...address, [property]: value }
            } else {
                property == "country" ?
                    updtAdd = { ...address, [property]: "", ["state"]: "" } :
                    updtAdd = { ...address, [property]: "" }
            }
        } else {
            updtAdd = { ...address, [property]: value };
        }

        setAddress(updtAdd)
    }

    useEffect(() => {
        let stateList_updated = [];

        for (let obj of countryList) {
            if (address.country == obj.countryId) {
                stateList_updated = obj.stateList
            }
        }
        setStateList(stateList_updated)
    }, [address.country, countryList])



    const handleDynamicFormChange = (value, field, parentObjectFieldKey) => {
        setExtraData(prevExtraData => {
            const updatedData = { ...prevExtraData };
            if (parentObjectFieldKey) {
                const keys = parentObjectFieldKey.split('_');
                let currentLevel = updatedData;
                keys.forEach((key, index) => {
                    if (!currentLevel[key]) currentLevel[key] = {};
                    if (index === keys.length - 1) {
                        currentLevel[key][field] = value;
                    } else {
                        currentLevel = currentLevel[key];
                    }
                });
            } else {
                updatedData[field] = value;
            }
            return updatedData;
        });
    };

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    }

    const getFieldValue = (fieldKey, parentObjectFieldKey) => {
        if (parentObjectFieldKey) {
            const keys = parentObjectFieldKey.split('_');
            return keys.reduce((currentLevel, key) => currentLevel?.[key] || {}, extraData)[fieldKey];
        }
        return extraData[fieldKey];
    };

    const handleDateChange = useCallback((selectedDate) => {
        const formateddDate = moment(selectedDate).format('YYYY-MM-DD');
        handleDynamicFormChange(formateddDate, datePickerConfig.fieldKey, datePickerConfig.parentObjectFieldKey)
        tweekDatePicker(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [datePickerConfig]);

    const renderField = (resp, id, parentObjectFieldKey) => {
        const fieldValue = getFieldValue(resp.fieldKey, parentObjectFieldKey);
        const mandatoryMark = resp.mandatory ? <Text style={{ color: "red" }}>*</Text> : null;

        switch (resp.type) {
            case "address":
                return (
                    <View key={id} style={getStyles(['addressCointainer'])}>
                        <Text style={getStyles(['label'])} onPress={() => setOpenAddress(prev => !prev)}>{t('check_in.address.address')} {mandatoryMark}</Text>
                        {openAddress && (
                            <View style={getStyles(['addressChildCointainer'])}>
                                <CustomDropDown
                                    placeholder={t('check_in.address.select_country')}
                                    isSearchable={true}
                                    options={countryList?.map(opt => ({
                                        value: opt.countryId,
                                        label: opt.countryName
                                    }))}
                                    selectedOption={address.country}
                                    onSelectOption={(value) => addressHandler(value.value, "country")}
                                />
                                {stateList.length > 0 &&
                                    <CustomDropDown
                                        placeholder={t('check_in.address.select_state')}
                                        isSearchable={true}
                                        options={stateList.map(item => {
                                            return {
                                                value: item.stateId,
                                                label: item.stateName
                                            }
                                        })}
                                        selectedOption={address.state}
                                        onSelectOption={(e) => addressHandler(e, "state")}
                                    />
                                }
                                <CustomTextInput
                                    value={address.addressLine1}
                                    onChangeText={(value) => addressHandler(value, "addressLine1")}
                                    placeholder={t('check_in.address.addressLine1')}
                                    autocomplete={"address-line1"}
                                />
                                <CustomTextInput
                                    value={address.addressLine2}
                                    onChangeText={(value) => addressHandler(value, "addressLine2")}
                                    placeholder={t('check_in.address.addressLine2')}
                                    autocomplete={"address-line2"}
                                />
                                <CustomTextInput
                                    value={address.city}
                                    onChangeText={(value) => addressHandler(value, "city")}
                                    placeholder={t('check_in.address.city')}
                                />
                                <CustomTextInput
                                    value={address.postalCode}
                                    onChangeText={(value) => addressHandler(value, "postalCode")}
                                    placeholder={t('check_in.address.postalCode')}
                                    autocomplete={"postal-code"}
                                />
                            </View>
                        )}
                    </View>
                );
            case "select":
            if((!resp.dependency || (resp.dependencyData?.dependencyValue == getNestedValue(extraData, resp.dependencyData.dependencyfieldKey) ))){
                return (
                    <View key={id}>
                        <CustomDropDown
                            label={resp.fieldName}
                            placeholder={resp.placeholder}
                            isRequired={mandatoryMark}
                            isSearchable={false}
                            options={resp.option.map(opt => ({
                                value: opt.value,
                                label: opt.displayName
                            }))}
                            selectedOption={fieldValue}
                            onSelectOption={(value) => handleDynamicFormChange(value.value, resp.fieldKey, parentObjectFieldKey)}
                        />
                    </View>
                )}
            return null;

            case "date":
            if((!resp.dependency || (resp.dependencyData?.dependencyValue == getNestedValue(extraData, resp.dependencyData.dependencyfieldKey) ))){
                return (
                    <>
                        <View key={id} style={getStyles(['textContainer'])}>
                            {resp.fieldName && <Text style={getStyles(['label'])}>{resp.fieldName} {mandatoryMark}</Text>}
                            <CustomPressable onPress={() => tweekDatePicker(true, fieldValue, resp.fieldKey, parentObjectFieldKey)}>
                                <CustomTextInput
                                    value={fieldValue ? formatDate(fieldValue, dateFormat) : ''}
                                    placeholder={resp.placeholder}
                                    editable={false}
                                    pointerEvents="none"
                                />
                            </CustomPressable>
                        </View>
                    </>
                )
            }
            return null;

            case "textarea":
            case "text":
            if((!resp.dependency || (resp.dependencyData?.dependencyValue == getNestedValue(extraData, resp.dependencyData.dependencyfieldKey) ))){
                return (
                    <View key={id} style={getStyles(['textContainer'])}>
                        {resp.fieldName && <Text style={getStyles(['label'])}>{resp.fieldName} {mandatoryMark}</Text>}
                        <CustomTextInput
                            value={fieldValue}
                            onChangeText={(value) => handleDynamicFormChange(value, resp.fieldKey, parentObjectFieldKey)}
                            placeholder={resp.placeholder}
                        />
                    </View>
                );
            }
            return null;

            case "tel":
            if((!resp.dependency || (resp.dependencyData?.dependencyValue == getNestedValue(extraData, resp.dependencyData.dependencyfieldKey) ))){
                return (
                    <View key={id} style={getStyles(['textContainer'])}>
                        {resp.fieldName && <Text style={getStyles(['label'])}>{resp.fieldName} {mandatoryMark}</Text>}
                        <CustomTextInput
                            value={fieldValue}
                            onChangeText={(value) => handleDynamicFormChange(value, resp.fieldKey, parentObjectFieldKey)}
                            placeholder={resp.placeholder}
                            keyboardType="phone-pad"
                            maxLength={15}
                        />
                    </View>
                );
            }
            return null;

            case "email":
            if((!resp.dependency || (resp.dependencyData?.dependencyValue == getNestedValue(extraData, resp.dependencyData.dependencyfieldKey) ))){
                return (
                    <View key={id} style={getStyles(['textContainer'])}>
                        {resp.fieldName && <Text style={getStyles(['label'])}>{resp.fieldName} {mandatoryMark}</Text>}
                        <CustomTextInput
                            value={fieldValue}
                            onChangeText={(value) => handleDynamicFormChange(value, resp.fieldKey, parentObjectFieldKey)}
                            placeholder={resp.placeholder}
                            autocomplete={"email"}
                            keyboardType="email-address"
                        />
                    </View>
                );
            }
            return null;

            case "eta":
            if((!resp.dependency || (resp.dependencyData?.dependencyValue == getNestedValue(extraData, resp.dependencyData.dependencyfieldKey) ))){
                return (
                    <View key={id}>
                        <CustomDropDown
                            label={resp.fieldName}
                            placeholder={resp.placeholder}
                            isRequired={mandatoryMark}
                            options={etaList?.filter(time => time >= (resp.minETA || "00:00")).map(time => ({
                                value: time,
                                label: formatEstimateCheckInTime(time, TIME_FORMAT)
                            }))}
                            selectedOption={fieldValue}
                            onSelectOption={(value) => handleDynamicFormChange(value.value, resp.fieldKey, parentObjectFieldKey)}
                        />
                    </View>
                );
            }
            return null;

            case "nestedObject":
            if((!resp.dependency || (resp.dependencyData?.dependencyValue == getNestedValue(extraData, resp.dependencyData.dependencyfieldKey) ))){
                return (
                    <View key={id} style={getStyles(['dynamicFormChildContainer_nestedObjContainer'])}>
                        {resp.fieldName && <Text style={getStyles(['dynamicFormChildContainer_nestedObjContainer_heading'])}>{resp.fieldName} {mandatoryMark}</Text>}
                        {resp.fieldName && <Text style={getStyles(['dynamicFormChildContainer_nestedObjContainer_description'])}>{resp.fielddesctiption}</Text>}
                        <View style={getStyles(['dynamicFormChildContainer_nestedObjInnerContainer'])}>
                            {
                                resp.nestedKeys.map((nestedResp, index) => {
                                    return renderField(nestedResp, id + index, parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey);
                                })
                            }
                        </View>
                    </View>
                )
            }
            return null;
            case "agreement":
                const dynamicFormCheckBoxText = getStyles(['dynamicFormCheckBoxText']);
                if((!resp.dependency || (resp.dependencyData?.dependencyValue == getNestedValue(extraData, resp.dependencyData.dependencyfieldKey) ))){
                    return (
                        <View key={id} style={getStyles(['dynamicFormCheckboxContainer'])}>
                            <CustomCheckBoxWithProps
                                value={fieldValue}
                                onValueChange={() => handleDynamicFormChange(!fieldValue, resp.fieldKey, parentObjectFieldKey)}
                                checkBoxStyle={getStyles(['dynamicFormCheckBox'])}
                            />
                            <RenderHTML 
                                contentWidth={width}
                                baseStyle={dynamicFormCheckBoxText}
                                source={{ html: resp.textInput}}
                                systemFonts={[dynamicFormCheckBoxText.fontFamily]}
                                id={`dynamicFormCheckBoxText`}
                            />
                        </View> 
                    );
                }
                return null;
            case "noticeText":
                const dynamicFormNoticeText = getStyles(['dynamicFormNoticeText']);
                return (
                    <View key={id}>
                        <RenderHTML 
                            contentWidth={width}
                            baseStyle={{...dynamicFormNoticeText, color: resp.textColor}}
                            source={{ html: resp.textInput}}
                            systemFonts={[dynamicFormNoticeText.fontFamily]}
                            id={`dynamicFormNoticeText`}
                        />
                    </View>
                );
            default:
                return null;
        }
    };



    const handleDynamicDataOnFirstLoad = (resp) => {

        const fieldValueMappings = {
            name: `${guestDetails.firstName} ${guestDetails.lastName}`,
            firstName: guestDetails.firstName,
            first_name: guestDetails.firstName,
            lastname: guestDetails.lastName,
            last_name: guestDetails.lastName,
            email: guestDetails.email,
            phone: guestDetails.phone,
            phonenumber: guestDetails.phone,
            phone_number: guestDetails.phone,
            mobile_number: guestDetails.phone,
            eta: guestDetails.checkInTime || mobileCheckInConfigs?.checkInStartTime?.slice(0, 5) || "",
            birthdate: guestDetails.birthDate,
            arrivaldate: guestDetails.arrivalDate?.split("T")[0],
            departuredate: guestDetails.departureDate?.split("T")[0],
        };

        const getFieldValue = (fieldKey) => fieldValueMappings[fieldKey] || "";

        const handleNestedObjectKeys = (response, parentObjectFieldKey, parentDataRef) => {
            let nestedObjectData = {};

            response.nestedKeys.forEach((nestedResp) => {
                const currentFieldKey = parentObjectFieldKey ? `${parentObjectFieldKey}_${nestedResp.fieldKey}` : nestedResp.fieldKey;

                if (nestedResp.type === "nestedObject") {
                    nestedObjectData[response.fieldKey] = {
                        ...nestedObjectData[response.fieldKey],
                        ...handleNestedObjectKeys(nestedResp, currentFieldKey, parentDataRef?.[nestedResp.fieldKey])
                    };
                } else if (nestedResp.type === "address") {
                    if (nestedResp.mandatory !== undefined) setIsAddressMandatory(nestedResp.mandatory);
                    if (nestedResp.openAddressDefault !== undefined) setOpenAddress(nestedResp.openAddressDefault);
                } else if (nestedResp.fieldKey) {
                    nestedObjectData[response.fieldKey] = {
                        ...nestedObjectData[response.fieldKey],
                        [nestedResp.fieldKey]: parentDataRef?.[nestedResp.fieldKey] || getFieldValue(nestedResp.fieldKey) || nestedResp.value || ""
                    };
                }
            });

            return nestedObjectData;
        };

        if (resp.type === "nestedObject") {
            const nestedObjectData = handleNestedObjectKeys(resp, resp.fieldKey, dynamicFormDataValue[resp.fieldKey]);
            setExtraData(extraData => ({ ...extraData, ...nestedObjectData }));
        } else if (resp.type === "address") {
            if (resp.mandatory !== undefined) setIsAddressMandatory(resp.mandatory);
            if (resp.openAddressDefault !== undefined) setOpenAddress(resp.openAddressDefault);
        } else if (resp.fieldKey) {
            setExtraData(extraData => ({
                ...extraData,
                [resp.fieldKey]: dynamicFormDataValue[resp.fieldKey] || getFieldValue(resp.fieldKey) || resp.value || ""
            }));
        }
    };


    useEffect(() => {
        console.log(extraData)
    }, [extraData])

    useEffect(() => {
        generateETAList();
        if (guestDetails.address) {
            setAddress({ ...address, ...guestDetails.address });
        }

        dynamicFormData.map((resp) => {
            handleDynamicDataOnFirstLoad(resp);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
        <View style={getStyles(['dynamicFormMainContainer'])} >

            <CustomFlatList
                data={dynamicFormData}
                renderItem={({ item, index }) => (
                    renderField(item, index)
                )}
                contentContainerStyle={getStyles(['dynamicFormChildContainer'])}
                keyExtractor={(item, index) => index.toString()}

                ListFooterComponent={
                    <View style={getStyles(['dynamicFormButtonContainer'])}>
                        <CustomPressable
                            style={getStyles(['primaryBtn'])}
                            onPress={handleFormSubmit}
                        >
                            <Text style={getStyles(['primaryBtnTxt'])}>{primaryBtnTxt || 'Next'}</Text>
                        </CustomPressable>

                        <CustomPressable
                            style={getStyles(['secondaryBtn'])}
                            onPress={handleGoBack}
                        >
                            <Text style={getStyles(['secondaryBtnTxt'])}>{secondaryBtnTxt || "Back"}</Text>
                        </CustomPressable>
                    </View>
                }
            />

        </View>

        {datePickerConfig.isVisible &&
            <DatePickerModal
                selectedDate={datePickerConfig.selectedDate}
                onDateChange={handleDateChange}
                onClose={() => tweekDatePicker(false)}
            />
        }
        </>
    );
};